import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { EditorModule } from '@tinymce/tinymce-angular';

import { ButtonModule } from '@shared/components/button/button.module';
import { MaterialModule } from '@app/material/material.module';

import { GuidanceNotesEditorDialogComponent } from './guidance-notes-editor-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    ReactiveFormsModule,
    MaterialModule,
    EditorModule
  ],
  declarations: [GuidanceNotesEditorDialogComponent],
  entryComponents: [GuidanceNotesEditorDialogComponent]
})
export class GuidanceNotesEditorDialogModule { }
